export default __webpack_public_path__ + "static/media/share-icon.69e5aeb0.svg";